import React from 'react'
import Quote from './components/Quote'
import './App.css';

function App() {
  return (
    <div className="App">
      <Quote />
    </div>
  );
}

export default App;

